import { ReactNode } from 'react';
import AlreadyPurchasedContainer from './AlreadyPurchasedContainer';
import { AlreadyPurchasedContainerProps } from '@msc-b2c/interfaces/types';

export function AlreadyPurchasedContainerWrapper({
  title,
  editButtonLabel,
  viewDetailButtonLabel,
  specialtyRestaurantMakeReservationLabel,
  specialtyRestaurantRequestRefundLabel,
  specialtyRestaurantReservationsLabel,
  specialtyRestaurantPassengersLabel,
  specialtyRestaurantConfirmReservationLabel,
  diningBannerTitle,
  diningBannerIcon,
  diningBannerBackgroundColor,
  diningBannerFontColor,
  diningBannerText,
  diningTimeslotsUnavailableBannerTitle,
  diningTimeslotsUnavailableBannerBody,
  diningTimeslotsUnavailableBannerIcon,
  diningTimeslotsUnavailableBannerBgColor,
  diningTimeslotsUnavailableBannerFontColor,
  passengerDetailsSeparator,
}: Readonly<AlreadyPurchasedContainerProps>): ReactNode {
  const props = {
    title,
    editButtonLabel,
    viewDetailButtonLabel,
    specialtyRestaurantMakeReservationLabel,
    specialtyRestaurantRequestRefundLabel,
    specialtyRestaurantReservationsLabel,
    specialtyRestaurantPassengersLabel,
    specialtyRestaurantConfirmReservationLabel,
    diningBannerTitle,
    diningBannerIcon,
    diningBannerBackgroundColor,
    diningBannerFontColor,
    diningBannerText,
    diningTimeslotsUnavailableBannerTitle,
    diningTimeslotsUnavailableBannerBody,
    diningTimeslotsUnavailableBannerIcon,
    diningTimeslotsUnavailableBannerBgColor,
    diningTimeslotsUnavailableBannerFontColor,
    passengerDetailsSeparator,
  };

  return <AlreadyPurchasedContainer {...props} />;
}

export default AlreadyPurchasedContainerWrapper;

AlreadyPurchasedContainerWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/alreadypurchasedcontainer';
